import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d731f622"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-layout-header fixed" }
const _hoisted_2 = { class: "app-layout-header-inner" }
const _hoisted_3 = { class: "app-layout-header-nav" }
const _hoisted_4 = { class: "app-layout-header-nav-left" }
const _hoisted_5 = { class: "app-layout-header-nav-right" }
const _hoisted_6 = { class: "action action-fullscreen" }
const _hoisted_7 = { class: "action" }
const _hoisted_8 = { class: "action-button-inner" }
const _hoisted_9 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hamburger = _resolveComponent("hamburger")!
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_fullscreen = _resolveComponent("fullscreen")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_User = _resolveComponent("User")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_hamburger, {
            onToggleClick: _ctx.handleToggleSideBar,
            "is-actived": _ctx.opened,
            class: "hamburger-container"
          }, null, 8, ["onToggleClick", "is-actived"]),
          (_ctx.pageHeader.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.pageHeader.includes('breadcrumb'))
                  ? (_openBlock(), _createBlock(_component_breadcrumb, {
                      key: 0,
                      class: "app-breadcrumb hide-in-mobile"
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: "全屏",
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_fullscreen)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_dropdown, {
              class: "action-button",
              trigger: "hover",
              placement: "top"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, { placement: "bottom-end" }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "dropdown-menu", {}, undefined, true)
                  ]),
                  _: 3
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_User)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.accountData?.username || '-'), 1)
                ])
              ]),
              _: 3
            })
          ])
        ])
      ])
    ])
  ]))
}